import {match, Pattern} from 'ts-pattern';

import {isNotNil} from 'ramda';

type ApiErrorInfo = {message: string; status?: number};

const FALLBACK_MESSAGE = 'API request failed';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && isNotNil(value);

const getErrorMessage = (errorField: unknown, status: number | undefined): string =>
  match({errorField, status})
    .with({errorField: Pattern.string}, ({errorField: error}) => error)
    .with({status: Pattern.number}, ({status: code}) => `Request failed with status ${code}`)
    .otherwise(() => FALLBACK_MESSAGE);

/**
 * Extracts a sanitized `{message, status?}` from an RTK Query rejected payload
 * (`FetchBaseQueryError`). Deliberately never reads `data` (the response body) — that may contain
 * customer PII and is out of scope per the snapshot's externalUntrusted handling.
 */
export const getApiErrorInfo = (payload: unknown): ApiErrorInfo => {
  if (!isRecord(payload)) {
    return {message: FALLBACK_MESSAGE};
  }

  const status = typeof payload.status === 'number' ? payload.status : undefined;
  const message = getErrorMessage(payload.error, status);

  return isNotNil(status) ? {message, status} : {message};
};
